import { type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';

import { Button, FilesDropZone } from '@gitbook/spine-react';

/**
 * A file upload field for OpenAPI spec.
 */
export function OpenAPIFileUploadField<TFieldValues extends FieldValues>(props: {
    control: Control<TFieldValues>;
    name: FieldPath<TFieldValues>;
    disabled?: boolean;
}) {
    const { control, disabled, name } = props;
    const { field } = useController({ control, name });
    const handleFileUpload = (files: File[]) => {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            if (e.target && typeof e.target.result === 'string') {
                field.onChange({ name: file.name, content: e.target.result });
            }
        };
        reader.readAsText(file);
    };
    return (
        <>
            {field.value ? (
                <div className="flex h-52 w-full flex-col rounded border">
                    <div className="flex items-center justify-between border-b px-4 py-2">
                        <div className="truncate">{field.value.name}</div>
                        <Button
                            ref={field.ref}
                            kind="secondary"
                            size="small"
                            label="Remove"
                            onPress={() => field.onChange(null)}
                            disabled={disabled || field.disabled}
                            onBlur={field.onBlur}
                        />
                    </div>
                    <div className="overflow-auto">
                        <pre className="m-0 px-4 py-2 font-mono text-xs">{field.value.content}</pre>
                    </div>
                </div>
            ) : (
                <FilesDropZone
                    acceptedFileTypes="openapi"
                    onSelectFiles={handleFileUpload}
                    disabled={disabled || field.disabled}
                />
            )}
        </>
    );
}
